(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clinic-name', {
            parent: 'entity',
            url: '/clinic-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.clinicName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clinic-name/clinic-names.html',
                    controller: 'ClinicNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clinicName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('clinic-name-detail', {
            parent: 'entity',
            url: '/clinic-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.clinicName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clinic-name/clinic-name-detail.html',
                    controller: 'ClinicNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clinicName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ClinicName', function($stateParams, ClinicName) {
                    return ClinicName.get({id : $stateParams.id});
                }]
            }
        })
        .state('clinic-name.new', {
            parent: 'clinic-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clinic-name/clinic-name-dialog.html',
                    controller: 'ClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('clinic-name', null, { reload: true });
                }, function() {
                    $state.go('clinic-name');
                });
            }]
        })
        .state('clinic-name.edit', {
            parent: 'clinic-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clinic-name/clinic-name-dialog.html',
                    controller: 'ClinicNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClinicName', function(ClinicName) {
                            return ClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('clinic-name.delete', {
            parent: 'clinic-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/clinic-name/clinic-name-delete-dialog.html',
                    controller: 'ClinicNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClinicName', function(ClinicName) {
                            return ClinicName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('clinic-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
